import React, { useState } from 'react';
import {
  Card,
  CardContent,
  Typography,
  Divider,
  Box,
  IconButton,
  Collapse,
} from '@mui/material';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

import { serviceTypeDetails, subLineMap } from '../../enum/serviceType';
import ServiceGrid from './ServiceGrid'; // Adjust path accordingly

function StopSummaryPanel({ stops }) {
  const [expandedService, setExpandedService] = useState(null);
  const [isExpanded, setIsExpanded] = useState(false); // For whole panel

  const handleToggleService = (serviceType) => {
    setExpandedService((prev) => (prev === serviceType ? null : serviceType));
  };

  const fixedServices = serviceTypeDetails.filter(
    (s) => s.type === 'LRT' || s.type === 'MRT'
  );
  const otherServices = serviceTypeDetails.filter(
    (s) => s.type !== 'LRT' && s.type !== 'MRT'
  );

  return (
    <Card elevation={3} sx={{ borderRadius: 1 }}>
      <CardContent>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
            userSelect: 'none',
          }}
          onClick={() => setIsExpanded((prev) => !prev)}
          aria-expanded={isExpanded}
          aria-label={isExpanded ? 'Collapse Stop Summary' : 'Expand Stop Summary'}
        >
          <Typography
            variant="h6"
            fontWeight="bold"
            sx={{
              fontSize: { xs: 16, sm: 20 },
              flexGrow: 1,
              userSelect: 'none',
            }}
          >
            Stop Summary
          </Typography>
          <IconButton
            size="small"
            edge="end"
            aria-label={isExpanded ? 'Collapse' : 'Expand'}
            onClick={(e) => {
              e.stopPropagation();
              setIsExpanded((prev) => !prev);
            }}
          >
            {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </Box>

        <Divider sx={{ my: 1 }} />

        <Collapse in={isExpanded} timeout="auto" unmountOnExit>
          {/* Fixed top row with LRT and MRT */}
          <ServiceGrid
            stops={stops}
            services={fixedServices}
            expandedService={expandedService}
            onToggle={handleToggleService}
            subLineMap={subLineMap}
          />

          {/* Other services in grid */}
          <Box sx={{ mt: 3 }}>
            <ServiceGrid
              stops={stops}
              services={otherServices}
              expandedService={expandedService}
              onToggle={handleToggleService}
              subLineMap={subLineMap}
            />
          </Box>
        </Collapse>
      </CardContent>
    </Card>
  );
}

export default StopSummaryPanel;
